import { Record } from 'immutable';
export default Record({
  url: null,
  manualCode: null
}, 'GoogleAuthQRCode');